/**
 * Admin-API: User Stories (Product) — zentraler HTTP-Zugriff (kein fetch in UI-Bausteinen).
 */

function authHeaders(token) {
  return { Authorization: "Bearer " + (token || "") };
}

export async function listUserStories({ apiBase, token }) {
  const r = await fetch(`${apiBase}/api/admin/members-userstories`, {
    headers: authHeaders(token),
  });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j.error || "Laden fehlgeschlagen");
  return Array.isArray(j.user_stories) ? j.user_stories : [];
}

export async function createUserStory({ apiBase, token, title, description }) {
  const r = await fetch(`${apiBase}/api/admin/members-userstories`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeaders(token) },
    body: JSON.stringify({ title, description: description || "" }),
  });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j.error || "Speichern fehlgeschlagen");
  return j;
}

export async function updateUserStory({ apiBase, token, id, title, description }) {
  const r = await fetch(`${apiBase}/api/admin/members-userstories/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeaders(token) },
    body: JSON.stringify({ title, description: description || "" }),
  });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j.error || "Speichern fehlgeschlagen");
  return j;
}

export async function deleteUserStory({ apiBase, token, id }) {
  const r = await fetch(`${apiBase}/api/admin/members-userstories/${id}`, {
    method: "DELETE",
    headers: authHeaders(token),
  });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j.error || "Löschen fehlgeschlagen");
  return j;
}

export async function listRatings({ apiBase, token, userStoryId }) {
  const r = await fetch(
    `${apiBase}/api/admin/members-userstories/${userStoryId}/ratings`,
    { headers: authHeaders(token) },
  );
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j.error || "Bewertungen konnten nicht geladen werden");
  return Array.isArray(j.ratings) ? j.ratings : [];
}

export async function addRating({ apiBase, token, userStoryId, score, comment }) {
  const r = await fetch(
    `${apiBase}/api/admin/members-userstories/${userStoryId}/ratings`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json", ...authHeaders(token) },
      body: JSON.stringify({ score, comment: comment || "" }),
    },
  );
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j.error || "Bewertung konnte nicht gespeichert werden");
  return j;
}

export async function deleteRating({ apiBase, token, userStoryId, ratingId }) {
  const r = await fetch(
    `${apiBase}/api/admin/members-userstories/${userStoryId}/ratings/${ratingId}`,
    { method: "DELETE", headers: authHeaders(token) },
  );
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j.error || "Löschen fehlgeschlagen");
  return j;
}
